export default "__VITE_ASSET__qSrLdGfS__"